<template>
  <div class="h-full overflow-y-scroll bg-white scrollbar-hide desk:h-auto desk:overflow-visible">
    <SearchGoods
      :title="title"
      :total="list.length"
      @getSearchContent="getSearchContent"
    />

    <LoadingVue v-if="fetching" class="mx-auto my-20 h-14" />
    <template v-else>
      <div class="px-3 pt-3 pb-5 desk:px-6 desk:pt-4 desk:pb-8">
        <div
          data-desktop-catalog-grid
          class="grid grid-cols-2 gap-x-2.5 gap-y-5 se:grid-cols-3 pc:grid-cols-4 desk:grid-cols-4 desk:gap-x-5 desk:gap-y-7 wide:grid-cols-5"
        >
          <ListItem
            v-for="(item, index) in list"
            :key="item.no"
            :item="item"
            :index="index"
          />
        </div>
      </div>

      <div class="px-6 py-16" v-if="!hasRecords">
        <p class="text-center text-sm text-gray-400">
          相關商品暫時缺貨
        </p>
      </div>
    </template>

    <div class="h-36 desk:hidden"></div>
  </div>
</template>

<script>
import ListItem from "@/components/product/ListItem";
import SearchGoods from "@/components/product/SearchGoods";
import LoadingVue from "@/components/icons/Loading.vue";
import { mapGetters } from "vuex";
import { toLower } from "lodash";
import { isDesktopWidth } from '@/utils/desktopChrome';
export default {
  components: {
    ListItem,
    SearchGoods,
    LoadingVue,
  },

  data() {
    return {
      trackedListKey: null,
    };
  },

  methods: {
    getSearchContent(value) {
      this.mapQuery({
        keywords: value,
      });
    },
    trackViewItemList() {
      if (!this.$track || !this.hasRecords) return;

      const listId =
        this.$route.query.category ||
        this.$route.query.catalog ||
        this.$route.query.keywords ||
        "all";
      const listKey = `${listId}:${this.list.map((item) => item.no || item.id).join(",")}`;

      if (this.trackedListKey === listKey) return;

      this.trackedListKey = listKey;
      this.$track.viewItemList(this.list, {
        id: listId,
        name: this.title,
        searchTerm: this.$route.query.keywords,
      });
    },
  },

  computed: {
    ...mapGetters({
      categories: "app/categories",
      fetching: "app/fetching",
    }),
    title() {
      return this.$route.query.title || "全部商品";
    },
    list() {
      const catalog = this.$route.query.catalog;
      const category = this.$route.query.category;
      const keywords = this.$route.query.keywords;
      const sameValue = (item, value) => String(item?.no ?? item?.id) === String(value);

      let list = [...this.categories];

      if (catalog) {
        list = list.filter((item) => {
          return item.parents.some(
            (p) =>
              sameValue(p, catalog) ||
              p.parents?.some((pp) => sameValue(pp, catalog)),
          );
        });
      }

      if (category) {
        list = list.filter((item) => {
          return (
            item.parents.some((i) => sameValue(i, category)) ||
            item.parents.some((i) => i.parents?.some((ii) => sameValue(ii, category)))
          );
        });
      }

      if (keywords) {
        list = list.filter((item) => {
          return toLower(item.name).includes(toLower(keywords));
        });
      }

      list = list.sort((a, b) => {
        const aParents = a.parents.map((i) => i.order);
        const bParents = b.parents.map((i) => i.order);
        const aOrder = aParents[aParents.length - 1];
        const bOrder = bParents[bParents.length - 1];
        return aOrder - bOrder;
      });

      list = list.sort((a, b) => {
        return a.order - b.order;
      });

      return list;
    },
    hasRecords() {
      return this.list && this.list.length != 0;
    },
  },
  watch: {
    list: {
      handler() {
        this.$nextTick(() => {
          this.trackViewItemList();
        });
      },
      immediate: true,
    },
    "$route.query": {
      handler() {
        this.$nextTick(() => {
          const desktop =
            typeof window !== "undefined" && isDesktopWidth(window.innerWidth);
          const container = desktop ? null : this.$el;
          if (container && typeof container.scrollTo === "function") {
            container.scrollTo({
              top: 0,
              behavior: "smooth",
            });
          }
          this.trackViewItemList();
        });
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped></style>
